import React, { useState, useEffect, useRef } from 'react';
import s from "./Devices.module.css"
import { useUser } from '../../Context/UserContext';
import TreeDiv from '../AddressTree/AddressTree';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../../hooks/mobileHook';
import { showAccessAlert } from "../Utils/Utils";
import { fetchDeviceList, exportDevicesToExcel } from "../../Api//DevicesApi"
import AddDeviceDialogNbiot from './AddDeviceDialogNbiot';
import AddDeviceDialogLora from './AddDeviceDialogLora';
import DevicesTable from './DevicesTable';



function formatDate(lastDateTime) {
    if (lastDateTime === 0) {
        return "Нет данных";
    } else {
        return new Date(lastDateTime * 1000).toLocaleDateString('ru-RU');
    }
}


export default function Devices({ onButtonClick, handleLogsClick }) {
    const isMobile = useIsMobile();

    const { user } = useUser();
    const notAllowedGroups = ['USER'];
    const isNotAllowed = notAllowedGroups.includes(user.role);

    const [isOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState(null);

    const toggleMenu = () => {
        setIsOpen((prev) => !prev);
    };

    const handleSelect = (type) => {
        console.log("Выбрано:", type);
        setModalType(type);
        setShowTosModal(true);
        setIsOpen(false);
    };

    const [showTosModal, setShowTosModal] = useState(false);

    const [searchAddressQuery, setSearchAddressQuery] = useState('');

    const [total, setTotal] = useState(null)
    const [devicesList, setDevice] = useState([])

    const [fullAddress, setFullAddress] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const [openTree, setOpenTree] = useState(false)
    const [openMenu, setOpenMenu] = useState(false)
    const popupRef = useRef(null);
    const buttonRef = useRef(null);
    const popupRefM = useRef(null);
    const buttonRefM = useRef(null);

    const [loading, setLoading] = useState(false);


    const handleClose = async () => {
        setModalType(false)
        setShowTosModal(false);
    }

    const fetchDevices = async () => {
        try {
            setLoading(true);
            // Пока используем старый API с пагинацией
            // Позже замените на новый API без пагинации
            const devices = await fetchDeviceList();
            setDevice(devices);
        } catch (error) {
            console.error('Error fetching devices:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    const handleFullAddressChange = (address) => {
        if (JSON.stringify(fullAddress) !== JSON.stringify(address)) {
            setFullAddress(address);
        }
    };

    const handleItemClick = (event) => {
        event.stopPropagation();
        setOpenTree(true);
    };

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setOpenMenu(prevState => !prevState);
    };

    const handleExportClick = async (event) => {
        try {
            await exportDevicesToExcel({ user });
        } catch (error) {
            console.error('Error exporting devices:', error);
        }
    };

    const cancelClick = (e) => {
        e.stopPropagation();
        setFullAddress([])
        setDevice([])
    }

    const handleClickOutside = (event) => {
        if (
            popupRef.current && !popupRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)
        ) {
            setOpenTree(false);
        }
    };

    const handleClickOutsideM = (event) => {
        if (
            popupRefM.current && !popupRefM.current.contains(event.target) &&
            buttonRefM.current && !buttonRefM.current.contains(event.target)
        ) {
            setOpenMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutsideM);

        return () => {
            document.removeEventListener('mousedown', handleClickOutsideM);
        };
    }, []);


    return (
        <div className={s.main}>
            {/* <div className={s.searchFrame}>
                <input
                    type='text'
                    className={s.search}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder='Поиск по imei, devEUI или номеру'
                >
                </input>
                <img src={'/search.svg'}></img>
            </div> */}

            {!isMobile ? (
                <div className={s.actionFrame}>
                    <div className={s.devImport}
                        onClick={() => {
                            if (isNotAllowed) {
                                showAccessAlert();
                            } else {
                                onButtonClick();
                            }
                        }}>
                        <div className={s.devImportText}>Импорт устройств</div>
                    </div>
                    <div className={s.frame13} onClick={handleExportClick}>
                        <div className={s.frame13Text}>Экспорт файла</div>
                    </div>
                    <div className={s.frame14} onClick={handleLogsClick}>
                        <img src={'/log.svg'} alt="" />
                        <div className={s.frame14Text}>Лог</div>
                    </div>
                    <div className={s.frame15} onClick={() => {
                        if (isNotAllowed) {
                            showAccessAlert();
                        } else {
                            toggleMenu();
                        }
                    }}>
                        <img src={'/add.svg'} alt="" />
                        <div className={s.frame15Text}>Добавить</div>
                        {isOpen && (
                            <div className={s.dropdown}>
                                <button onClick={() => handleSelect("lora")}>LoRa</button>
                                <button onClick={() => handleSelect("nbiot")}>NB-IoT</button>
                            </div>
                        )}
                    </div>



                    {modalType === "nbiot" && (
                        <AddDeviceDialogNbiot showTosModal={showTosModal} handleClose={handleClose} />
                    )}
                    {modalType === "lora" && (
                        <AddDeviceDialogLora showTosModal={showTosModal} handleClose={handleClose} />
                    )}

                </div>
            ) : (
                <div className={s.actionMobileFrame} onClick={handleMenuClick} ref={buttonRefM}>
                    <div className={s.warpFrame} >

                        <div className={s.actionMobileText}>Действия</div>
                        <div className={s.arrowDown}>
                            <img src={'/arrowback.svg'}></img>

                        </div>
                    </div>

                    {openMenu && (
                        <div className={s.menuPopup} ref={popupRefM}>
                            <div className={s.menuPopupWarp}>
                                <div className={s.devImport}
                                    onClick={() => {
                                        if (isNotAllowed) {
                                            showAccessAlert();
                                        } else {
                                            onButtonClick();
                                        }
                                    }}>
                                    <div className={s.devImportText}>Импорт устройств</div>
                                </div>
                                <div className={s.frame13} onClick={handleExportClick}>
                                    <div className={s.frame13Text}>Экспорт файла</div>
                                </div>
                                <div className={s.frame14} onClick={handleLogsClick}>
                                    <img src={'/log.svg'} alt="" />
                                    <div className={s.frame14Text}>Лог</div>
                                </div>
                                <div className={s.frame15} >
                                    <img src={'/add.svg'} alt="" />
                                    <div className={s.frame15Text}>Добавить</div>
                                </div>

                            </div>
                        </div>
                    )}
                </div>
            )}
            <div className={s.addressWarp}>
                <div className={s.addressFrame} onClick={handleItemClick} ref={buttonRef}>
                    <div className={s.frame75} >
                        <div className={s.frame75logo}>
                            <img src={'/home.svg'}></img>
                        </div>
                        <div className={s.frame75Text}>Список адресов</div>
                        <div className={s.arrowDown}>
                            <img src={'/arrowback.svg'}></img>

                        </div>
                    </div>
                    {openTree && (
                        <div className={s.addressPopup} ref={popupRef}>
                            <div className={s.address}>
                                <div className={s.addressInput}>
                                    <input
                                        type='text'
                                        className={s.addressSearch}
                                        value={searchAddressQuery}
                                        onChange={(e) => setSearchAddressQuery(e.target.value)}
                                        placeholder='Поиск адреса'
                                    >
                                    </input>
                                    <img src={'/search.svg'}></img>
                                </div>
                                <div>
                                    <TreeDiv setSelectedAddress={(address) => {
                                        setSelectedAddress(address);
                                    }} handleFullAddressChange={handleFullAddressChange} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {/* {fullAddress.length > 0 && (
                    <div className={s.chosedAddr} onClick={cancelClick} >
                        <div className={s.chosedAddrImg}>
                            <img
                                src={'/cancel.svg'}
                                alt="cancel"
                            />
                        </div>
                        <div className={s.chosedAddrText}>
                            {fullAddress.join(', ')}
                        </div>

                    </div>
                )} */}
            </div>




            <DevicesTable devicesList={devicesList} loading={loading} searchAddressQuery={fullAddress} user={user} />


            {!isMobile ? (
                <></>
            ) : (
                <div className={s.podval}>
                </div>
            )}
        </div>
    )
}


